// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as TestUtils$OrcaPaymentPage from "../Utilities/TestUtils.bs.js";
import * as ConfirmType$OrcaPaymentPage from "../Types/ConfirmType.bs.js";
import * as PaymentType$OrcaPaymentPage from "../Types/PaymentType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentField$OrcaPaymentPage from "./PaymentField.bs.js";
import * as DynamicFieldsUtils$OrcaPaymentPage from "../Utilities/DynamicFieldsUtils.bs.js";

function BillingNamePaymentInput(props) {
  var optionalRequiredFields = props.requiredFields;
  var __customFieldName = props.customFieldName;
  var customFieldName = __customFieldName !== undefined ? Caml_option.valFromOption(__customFieldName) : undefined;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var match$2 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userBillingName);
  var setBillingName = match$2[1];
  var billingName = match$2[0];
  var showDetails = PaymentType$OrcaPaymentPage.getShowDetails(match$1.fields.billingDetails);
  var changeName = function (ev) {
    var val = ev.target.value;
    setBillingName(function (prev) {
          return {
                  value: val,
                  isValid: val !== "",
                  errorString: val !== "" ? "" : prev.errorString
                };
        });
  };
  var onBlur = function (ev) {
    var val = ev.target.value;
    setBillingName(function (prev) {
          var newrecord = Caml_obj.obj_dup(prev);
          newrecord.isValid = val !== "";
          return newrecord;
        });
  };
  var match$3 = customFieldName !== undefined ? [
      customFieldName,
      customFieldName
    ] : [
      localeString.billingNamePlaceholder,
      localeString.billingNameLabel
    ];
  var fieldName = match$3[1];
  var nameRef = React.useRef(null);
  var submitCallback = React.useCallback((function (ev) {
          var json = Utils$OrcaPaymentPage.safeParse(ev.data);
          var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
          if (confirm.doSubmit) {
            if (billingName.value === "") {
              return setBillingName(function (prev) {
                          var newrecord = Caml_obj.obj_dup(prev);
                          newrecord.errorString = localeString.nameEmptyText(fieldName);
                          return newrecord;
                        });
            } else if (optionalRequiredFields !== undefined && !DynamicFieldsUtils$OrcaPaymentPage.checkIfNameIsValid(optionalRequiredFields, "BillingName", billingName)) {
              return setBillingName(function (prev) {
                          var newrecord = Caml_obj.obj_dup(prev);
                          newrecord.errorString = localeString.completeNameEmptyText(fieldName);
                          return newrecord;
                        });
            } else {
              return ;
            }
          }
          
        }), [billingName]);
  Utils$OrcaPaymentPage.useSubmitPaymentData(submitCallback);
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: showDetails.name === "Auto",
              children: React.createElement(PaymentField$OrcaPaymentPage.make, {
                    setValue: setBillingName,
                    value: billingName,
                    onChange: changeName,
                    onBlur: onBlur,
                    fieldName: fieldName,
                    name: TestUtils$OrcaPaymentPage.cardHolderNameInputTestId,
                    type_: "text",
                    placeholder: match$3[0],
                    className: match.config.appearance.innerLayout === "Spaced" ? "" : "!border-b-0",
                    inputRef: nameRef
                  })
            });
}

var make = BillingNamePaymentInput;

export {
  make ,
}
/* react Not a pure module */
